import * as constants from 'containers/App/constants';

const initialState = {
  assignedTasks: null,
  leads: null,
  loginTasks: null,
  weddings: null,
};

export default (state = initialState, action, loginId) => {
  const { module: taskType, payload: results, weddingId, leadId, scope, isMyFocus } = action || {};
  const { payload, taskId, primaryKey, dataType, operation, oldIndex, newIndex } = action || {};
  const { assignedTasks, leads, loginTasks, weddings } = action.payload?.tasksInfo || state;
  const tasksInfo = state;

  let wedding = weddingId ? weddings.find(w => w.id === weddingId) : null;
  const lead = leadId ? state.leads.find(l => l.id === leadId) : null;
  const { deleted } = payload || {};

  let newTasks;
  let newAssignedTasks = assignedTasks;
  let newLeads = leads;
  let newLeadTasks;
  let newLoginTasks = loginTasks;
  let newWeddings = weddings;
  let newWeddingTasks;
  let newtasksInfo;
  let taskList;

  switch (action.type) {
    case constants.GET_FOCUS_TASKS_SUCCESS:
      newtasksInfo = { ...tasksInfo, assignedTasks: action.payload };
      return newtasksInfo;
    case constants.GET_TASKS_SUCCESS:
      // Ensure order of tasks.
      /*
      newAssignedTasks = [...assignedTasks].sort(sortTasks);
      newLeads = leads.map(l => {
        newLeadTasks = [...l.tasks].sort(sortTasks);
        return { ...l, tasks: newLeadTasks };
      });
      newWeddings = weddings.map(w => {
        newWeddingTasks = [...w.tasks].sort(sortTasks);
        return { ...w, tasks: newWeddingTasks };
      });
      newLoginTasks = [...loginTasks.tasks].sort(sortTasks);
      return {
        assignedTasks: newAssignedTasks,
        leads: newLeads,
        loginTasks: { ...loginTasks, tasks: newLoginTasks },
        weddings: newWeddings,
      };
      */
      newtasksInfo = { ...tasksInfo, ...action.payload.tasksInfo };
      return newtasksInfo;
    case constants.CREATE_NEW_TASK:
      return state;
    case constants.UPDATE_TASK_DETAIL:
      return state;
    case constants.UPDATE_TASK_DETAIL_SUCCESS:
      // #TODO: Clean up structure of different task types.
      if (assignedTasks) {
        newAssignedTasks = updateTaskDetails(assignedTasks, results);
      }
      if (results.hasWedding || taskType === 'weddings') {
        wedding = state.weddings.find(w => w.tasks.find(t => t.id === results.id) !== undefined);
        taskList = wedding?.tasks;
        if (taskList) {
          newTasks = updateTaskDetails(taskList, results);
          newWeddings = state.weddings.map(w => w.id === wedding.id ? { ...w, tasks: newTasks } : w);
          return { ...state, weddings: newWeddings, assignedTasks: newAssignedTasks };
        }
      } else if (results.hasLead || taskType === 'leads') {
        // #TODO: The logic for weddings and leads is very similar. Can probably condense this.
        taskList = lead?.tasks;
        if (taskList) {
          newTasks = updateTaskDetails(taskList, results);
          newLeads = state.leads.map(l => l.id === lead.id ? { ...l, tasks: newTasks } : l);
          return { ...tasksInfo, leads: newLeads, assignedTasks: newAssignedTasks };
        }
      } else {
        taskList = loginTasks?.tasks;
        if (taskList) {
          return {
            ...tasksInfo,
            loginTasks: { ...loginTasks, tasks: updateTaskDetails(taskList, results) },
            assignedTasks: newAssignedTasks,
          };
        }
      }
      // Should not happen.
      return state;
    case constants.DELETE_TASK:
      return state;
    case constants.DELETE_TASK_SUCCESS:
      // #TODO: Refactor task reducers into separate file to avoid variable name conflicts between cases.
      if (deleted) {
        newAssignedTasks = assignedTasks.filter(t => t.id !== taskId) || [];
        newLoginTasks = loginTasks.tasks.filter(t => t.id !== taskId);
        wedding = state.weddings.find(w => w.tasks.find(t => t.id === taskId) !== undefined);
        if (wedding?.tasks.find(t => t.id === taskId)) {
          newWeddingTasks = wedding?.tasks.filter(t => t.id !== taskId);
          newWeddings = state.weddings.map(w => w.id === wedding.id ? { ...w, tasks: newWeddingTasks } : w);
          return {
            ...tasksInfo,
            weddings: newWeddings,
            loginTasks: { ...state.loginTasks, tasks: newLoginTasks },
            assignedTasks: newAssignedTasks,
          };
        }
        if (lead?.tasks.find(t => t.id === taskId)) {
          newLeadTasks = lead?.tasks.filter(t => t.id !== taskId);
          newLeads = state.leads.map(l => l.id === lead.id ? { ...l, tasks: newLeadTasks } : l);
          return {
            ...tasksInfo,
            leads: newLeads,
            loginTasks: { ...state.loginTasks, tasks: newLoginTasks },
            assignedTasks: newAssignedTasks,
          };
        }
        return {
          ...tasksInfo,
          loginTasks: { ...state.loginTasks, tasks: newLoginTasks },
          assignedTasks: newAssignedTasks,
        };
      }
      // If delete mutation fails to delete task.
      return state;
    case constants.CREATE_NEW_COMMENT:
      return state;
    case constants.UPDATE_COMMENT_DETAIL:
      return state;
    case constants.DELETE_COMMENT:
      return state;
    case constants.ADD_NEW_ASSIGNMENT:
      return state;
    case constants.UPDATE_ASSIGNMENT:
      return state;
    case constants.DROP_ASSIGNMENT:
      return state;
    case constants.UPDATE_TASK_SUCCESS:
      if (assignedTasks) {
        newAssignedTasks = updateTasksData(assignedTasks, taskId, payload, primaryKey, dataType, operation, loginId);
      }
      if (leads) {
        newLeadTasks = leads.map(l => {
          newTasks = updateTasksData(l.tasks, taskId, payload, primaryKey, dataType, operation, loginId);
          return { ...l, tasks: newTasks };
        });
      }
      if (loginTasks) {
        newLoginTasks = updateTasksData(loginTasks.tasks, taskId, payload, primaryKey, dataType, operation, loginId);
      }
      if (weddings) {
        newWeddingTasks = weddings.map(m => {
          newTasks = updateTasksData(m.tasks, taskId, payload, primaryKey, dataType, operation, loginId);
          return { ...m, tasks: newTasks };
        });
      }

      newtasksInfo = {
        assignedTasks: newAssignedTasks,
        leads: newLeadTasks,
        loginTasks: { ...loginTasks, tasks: newLoginTasks },
        weddings: newWeddingTasks,
      };

      return newtasksInfo;
    case constants.TASK_REMINDER_SUCCESS:
      if (assignedTasks && (taskType === 'assignedTasks' || isMyFocus)) {
        if (payload?.created) newAssignedTasks = createReminders(assignedTasks, payload);
        else if (payload?.deleted) newAssignedTasks = deleteReminders(assignedTasks, payload);
        else newAssignedTasks = updateReminders(assignedTasks, payload);
      }

      if (leads && (taskType === 'leads' || scope === 'leads')) {
        if (payload?.created) newLeadTasks = createReminders(leads, payload);
        else if (payload?.deleted) newLeadTasks = deleteReminders(leads, payload);
        else newLeadTasks = updateReminders(leads, payload);
      }

      if (weddings && (taskType === 'weddings' || scope === 'weddings')) {
        if (payload?.created) newWeddingTasks = createReminders(weddings, payload);
        else if (payload?.deleted) newWeddingTasks = deleteReminders(weddings, payload);
        else newWeddingTasks = updateReminders(weddings, payload);
      }

      if (loginTasks && (taskType === 'loginTasks' || scope === 'loginTasks')) {
        if (payload?.created) newLoginTasks = createReminders(loginTasks.tasks, payload);
        else if (payload?.deleted) newLoginTasks = deleteReminders(loginTasks.tasks, payload);
        else newLoginTasks = updateReminders(loginTasks.tasks, payload);
      }

      return {
        assignedTasks: newAssignedTasks,
        leads: newLeadTasks,
        loginTasks: { ...loginTasks, tasks: newLoginTasks?.tasks ? newLoginTasks?.tasks : newLoginTasks },
        weddings: newWeddingTasks,
      };
    case constants.REORDER_TASK_COMPLETE:
      switch (taskType) {
        case 'loginTasks':
          newLoginTasks = { ...loginTasks, tasks: reorderTaskData(loginTasks, oldIndex, newIndex) };
          break;
        case 'weddings':
          newWeddingTasks = weddings.map(m => {
            newTasks = reorderTaskData(m.tasks, oldIndex, newIndex);
            return { ...m, tasks: newTasks };
          });
          break;
        case 'leads':
          newLeadTasks = leads.map(l => {
            newTasks = reorderTaskData(l.tasks, oldIndex, newIndex);
            return { ...l, tasks: newTasks };
          });
          break;
        case 'assignedTasks':
          newAssignedTasks = reorderTaskData(assignedTasks, oldIndex, newIndex);
          break;
        default:
          break;
      }

      return {
        assignedTasks: newAssignedTasks,
        leads: newLeadTasks,
        loginTasks: newLoginTasks,
        weddings: newWeddingTasks,
      };
    case constants.TASK_REMINDER_FAILURE:
      return state;
    case constants.CREATE_TASK_REMINDER:
      return state;
    case constants.UPDATE_TASK_REMINDER:
      return state;
    case constants.DELETE_TASK_REMINDER:
      return state;
    // When the api request to update a task was successful from another component,
    // and just need to update the state from that result.
    case constants.UPDATE_TASK_STORE_BY_ID:
      switch (taskType) {
        case 'loginTasks':
          if (!loginTasks) break;
          newLoginTasks = { ...loginTasks, tasks: updateTaskStoreById(loginTasks.tasks, action.payload) };
          break;
        case 'weddings':
          if (!weddings) break;
          newWeddingTasks = weddings.map(m => {
            newTasks = updateTaskStoreById(m.tasks, action.payload);
            return { ...m, tasks: newTasks };
          });
          break;
        case 'leads':
          if (!leads) break;
          newLeadTasks = leads.map(l => {
            newTasks = updateTaskStoreById(l.tasks, action.payload);
            return { ...l, tasks: newTasks };
          });
          break;
        default:
          break;
      }
      // Assigned tasks can be from all three task types.
      newAssignedTasks = updateTaskStoreById(assignedTasks, action.payload);
      return {
        assignedTasks: newAssignedTasks,
        leads: newLeadTasks,
        loginTasks: newLoginTasks,
        weddings: newWeddingTasks,
      };
    default:
      return state;
  }
};

// Find task and replace with updated data from response.
const updateTasksData = (tasks, taskId, payload, primaryKey, dataType, operation, loginId) => {
  if (tasks) {
    // Drop task completely if current user is unassigned.
    if (dataType === 'assignments' && operation === 'delete' && payload.loginId === loginId) {
      return tasks.filter(t => t.id !== taskId);
    }
    return tasks.map(t => {
      if (t.id === taskId) {
        const list = t[dataType] || [];
        let newList = null;

        switch (operation) {
          case 'create':
            newList = [...list, payload];
            break;
          case 'update':
            newList = list.map(item => {
              if (item[primaryKey] === payload[primaryKey]) {
                return payload;
              }
              return { ...item };
            });
            break;
          case 'delete':
            newList = list.filter(item => item[primaryKey] !== payload[primaryKey]);
            break;
          default:
            newList = null;
        }
        if (!newList) {
          return { ...t };
        }
        return { ...t, [dataType]: newList };
      }
      return { ...t };
    });
  }
};

const updateTaskDetails = (tasks, updatedTask) => {
  if (updatedTask?.completed) {
    return tasks.filter(t => t.id !== updatedTask.id);
  }

  return tasks.map(t => {
    if (t.id === updatedTask.id) {
      return { ...t, ...updatedTask };
    }
    return t;
  });
};

const arrayOneMove = (array, from, to) => {
  // eslint-disable-next-line no-param-reassign
  array = array.slice();
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  return array;
};

const reorderTaskData = (tasks, oldIndex, newIndex) => {
  return arrayOneMove(tasks, oldIndex, newIndex);
};

export const singleTaskReducer = (state = initialState, action) => {
  const { module: taskType, payload: results, taskId } = action || {};
  const tasksInfo = state;
  const { assignedTasks, leads, loginTasks, weddings } = tasksInfo;

  switch (action.type) {
    case constants.FETCH_SINGLE_TASK_SUCCESS:
      if (taskType === 'assignedTasks')
        return { ...tasksInfo, assignedTasks: getTasksUpdated(assignedTasks, taskId, results) };

      if (taskType === 'leads')
        return { ...tasksInfo, leads: getTasksUpdated(leads, taskId, results) };

      if (taskType === 'weddings')
        return { ...tasksInfo, weddings: getTasksUpdated(weddings, taskId, results) };

      if (taskType === 'loginTasks') {
        return {
          ...tasksInfo,
          loginTasks: {
            ...loginTasks,
            tasks: getTasksUpdated(loginTasks.tasks, taskId, results),
          },
        };
      }
      break;
    default:
      return state;
  }
};

// Updated Single Task
const getTasksUpdated = (tasks, replaceId, replacement) => {
  if (tasks) {
    return tasks.map(t => {
      if (t.tasks) {
        const newTasks = t.tasks.map(nt => {
          if (nt.id === replaceId) return { ...nt, ...replacement };
          return nt;
        });

        return { ...t, tasks: newTasks };
      }

      if (t.id === replaceId) return { ...t, ...replacement };
      return t;
    });
  }
};

// Add a new reminder in a list of tasks.
const createReminders = (tasks, payload) => {
  if (tasks) {
    return tasks.map(t => {
      if (t.tasks) {
        const newTasks = t.tasks.map(nt => {
          if (nt.id === payload.spec?.payload?.task_id) {
            const { reminders } = nt || { reminders: [] };

            const newReminders = [...reminders, payload];
            return { ...nt, reminders: newReminders };
          }
          return nt;
        });

        return { ...t, tasks: newTasks };
      }
      if (t.id === payload.spec?.payload?.task_id) {
        const { reminders } = t;

        const newReminders = [...reminders, payload];
        return { ...t, reminders: newReminders };
      }
      return t;
    });
  }
};

// Update a reminder in a list of tasks.
const updateReminders = (tasks, payload) => {
  if (tasks) {
    return tasks.map(t => {
      if (t.tasks) {
        const newTasks = updateReminders(t.tasks, payload);
        return { ...t, tasks: newTasks };
      }
      if (t.id === payload.spec?.payload?.task_id) {
        const { reminders } = t || {};

        const newReminders = reminders?.map(r => {
          if (r.id === payload?.id) {
            return { ...r, spec: payload.spec };
          }
          return { ...r };
        });
        if (reminders) {
          return { ...t, reminders: newReminders };
        }
        return t;
      }
      return t;
    });
  }
};

// Delete a reminder from a list of tasks.
const deleteReminders = (tasks, payload) => {
  if (tasks) {
    return tasks.map(t => {
      if (t.tasks) {
        const newTasks = t.tasks.map(nt => {
          if (nt.id === payload?.taskId && payload.deleted) {
            const { reminders } = nt || {};

            const newReminders = reminders.filter(r => r.id !== payload?.definitionId);
            return { ...nt, reminders: newReminders };
          }
          return nt;
        });
        return { ...t, tasks: newTasks };
      }
      if (t.id === payload?.taskId && payload.deleted) {
        const { reminders } = t;

        const newReminders = reminders.filter(r => r.id !== payload?.definitionId);
        return { ...t, reminders: newReminders };
      }
      return t;
    });
  }
};

/**
 * Updates the task within the store if the data modification came from a different area,
 * such as modify a task from the calendar.
 * @param {*} id - id of task to find.
 * @param {*} tasks - existing list of tasks
 * @param {*} data - data to modify within the task
 * @returns {array} List of tasks
 */
const updateTaskStoreById = (tasks, { id, data }) => {
  if (!tasks) return;

  const foundIndex = tasks.findIndex(task => task.id === id);
  if (foundIndex < 0) return tasks;

  const newTasks = [...tasks];
  newTasks[foundIndex] = { ...newTasks[foundIndex], ...data };
  return newTasks;
};
